import { createContext, useContext } from 'react';

/** The Detail section's header bar, where the open cart renders its header. */
export const DetailHeaderSlotContext = createContext<HTMLElement | null>(null);

export function useDetailHeaderSlot(): HTMLElement | null {
  return useContext(DetailHeaderSlotContext);
}
